import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function NoRouteView() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return <div />;
}

export default NoRouteView;